// core
import { Injectable } from '@angular/core';

// constants
import { EXTRAS_CONSTANTS } from '../constants/policy.constants';

interface ICoverInterface {
  policy_type: string;
  extras: any;
}

@Injectable({
  providedIn: 'root'
})
export class PolicyExtrasService {

  constructor() { }

  async getFormattedLegacyExtras(phase: any) {
    const extras: { active: any[], additional: any[] } = {
      active: [],
      additional: []
    };
    
    if (phase.extras) {
      for (const [key, value] of Object.entries(phase.extras)) {
        if (['SF', 'arrang_fee'].includes(key) === false) {
          const extraObj = {
            settings: {
              ...EXTRAS_CONSTANTS.active_setting.settings,
              title: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details]?.label || '',
              content: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details]?.info || '',
              iconName: ''
            }
          };
          value ? extras.active.push(extraObj) : extras.additional.push(extraObj);
        }
      }
    }

    return extras;
  }

  getFormattedExtras(policyExtras: any, productSlug: string) {
    const extras: { active: any[], additional: any[] } = {
      active: [],
      additional: []
    };
    
    if (policyExtras) {
      Object.entries(policyExtras).forEach(([key, extra]: [string, any]) => {
        let extraType = extra.is_included ? 'active' : 'additional';
        let extraObj = {
          settings: {
            ...EXTRAS_CONSTANTS[extraType + '_setting'].settings,
            title: extra.label || '',
            content: extra.description || '',
            link: extra.info_page || '',
            iconName: EXTRAS_CONSTANTS.extra_details[key as keyof typeof EXTRAS_CONSTANTS.extra_details]?.icon || ''
          }
        };
        if (extraType === 'active') {
          extraObj.settings.link = extra.info_page || '';
        }

        // Hack for Avios launch to map different extras descriptions based on product
        extraObj.settings.content = this.mapExtraContent(key, productSlug) || extraObj.settings.content;

        extraType === 'active' ? extras.active.push(extraObj) : extras.additional.push(extraObj);
      });
    }

    return extras;
  }

  mapExtraContent(extraKey: any, productSlug: string) {
    let extraDescriptions: any = {};

    if (['avs-travel-multi-25', 'avs-travel-multi-msm-25'].includes(productSlug)) {
      extraDescriptions = {
        brand_award: '3000 Avios bonus award',
        brand_lottery: 'Monthly entry',
        brand_protect: 'Up to 500,000 Avios covered per trip',
        cancellation_flex: 'More flexible cancellation cover',
        class_pass: 'ClassPass credits',
        cruise: 'Cover during your cruise and for related benefits',
        esim: '10GB global roaming data',
        flight_delay: 'Flight delayed? Get paid',
        gadget: 'Take your tech with confidence',
        snow: 'Cover for winter sport activities'
      };
    }
    if (['avs-travel-single-25', 'avs-uk-travel-24'].indexOf(productSlug) > -1) {
      extraDescriptions = {
        brand_award: '3000 Avios bonus award',
        brand_lottery: 'Monthly entry',
        brand_protect: 'Up to 500,000 Avios covered per trip',
        cancellation_flex: 'More flexible cancellation cover',
        cruise: 'Cover during your cruise and for related benefits',
        esim: '10GB global roaming data',
        flight_delay: 'Flight delayed? Get paid',
        gadget: 'Take your tech with confidence',
        snow: 'Cover for winter sport activities'
      };
    }
    return extraDescriptions[extraKey];
  }

  getPolicyExtrasByType = (policyType: string, covers: any) => {
    const filteredPolicy = Object.values(covers).find((cover) => (cover as ICoverInterface).policy_type === policyType) as ICoverInterface | undefined;
    
    return filteredPolicy ? filteredPolicy.extras : null;
  };
}